import Swal from 'sweetalert2';

export function calculateFuelCosts(litres, systemSettings) {
    const result = {};

    litres = parseFloat(litres);

    result.base = (litres * systemSettings['price per litre charged to client']) / 100;
    result.surcharge = result.base * (systemSettings['surcharge on fuel expense charged to client'] / 100);
    result.cost = Number((result.base + result.surcharge).toFixed(2));

    return result;
}

export function errorAlert(error, title) {
    let errorHtml;

    if (error.response?.data?.errors) {
        const errorMessages = error.response.data.errors;
        errorHtml = Object.values(errorMessages)
            .flat()
            .map(msg => `<p class="mb-0">${msg}</p>`)
            .join('');
    }
    else if (error.response?.data?.message) {
        errorHtml = `<p class="mb-0">${error.response.data.message}</p>`;
    }
    else if (error.message) {
        errorHtml = `<p class="mb-0">${error.message}</p>`;
    }
    else {
        errorHtml = '<p class="mb-0">An unexpected error occurred</p>';
    }

    Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'error',
        title: title || 'Error',
        html: errorHtml,
        timer: 3000,
        showConfirmButton: false,
        width: '600px',
    });
}

export function successAlert(message, title, timerInMs = 2000, redirect = false) {

    let timerInterval;

    const config = {
        toast: true,
        position: 'top-end',
        icon: 'success',
        title: title || 'Success',
        text: message,
        showConfirmButton: false,
        width: '500px',
        timer: timerInMs,
    };

    if (redirect) {
        let seconds = timerInMs !== undefined ? Math.round(timerInMs / 1000) : null;
        config.timerProgressBar = true;
        delete config.text;
        config.html = `<div>${message}</div><div id="redirect-timer" style="font-size:0.9em; color:#888;">Redirecting in ${seconds} Seconds</div>`;
        config.didOpen = () => {
            const timerEl = document.getElementById('redirect-timer');
            timerInterval = setInterval(() => {
                if (seconds > 1) {
                    seconds--;
                    timerEl.textContent = `Redirecting in ${seconds} Seconds`;
                }
            }, 1000);
        };
        config.willClose = () => {
            clearInterval(timerInterval);
        };
    }

    return Swal.fire(config);
}

export function getDateString(date) {
    if (!date) {
        return '';
    }

    if (typeof date === 'string') {
        date = new Date(date);
    }

    return date.toISOString().split('T')[0];
}

export function generateErrorResponse(errors) {
    return {
        response: {
            data: {
                errors: errors
            }
        }
    };
}
